// ** React Imports
import { useEffect, useState } from 'react';
import {
  isObjEmpty,
  selectThemeColors,
  getNumbersBigThatRecursive
} from '@utils';
// ** Utils

// ** Third Party Components
import * as yup from 'yup';
import { ArrowLeft, ArrowRight, DownloadCloud } from 'react-feather';
import { Formik } from 'formik';

// ** Reactstrap Imports
import SelectAsyncOptions from '@components/input/SelectAsyncOptions';
import { Form, Label, Input, Row, Col, Button, FormFeedback, FormGroup} from 'reactstrap';
import FileUploaderSingle from '@components/input/FileUploaderSingle';
import { ListTags } from '../../../../../graphql/Mutation';
import { FilterActivities } from '../../../../../graphql/Query/roads';
import { useMutation, useQuery } from '@apollo/client';
import api from '../../../../../graphql/api';

// ** Third Party Components
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const Options = Array(6)
  .fill()
  .map((i, idx) => (
    <option key={`${Date.now()}${idx}`} value={idx}>
      {idx}
    </option>
  ));

const handleWarning = () => {
  return MySwal.fire({
    title: 'Error!',
    text: ' Por favor carga una imagen antes de continuar.',
    icon: 'error',
    customClass: {
      confirmButton: 'btn btn-primary'
    },
    buttonsStyling: false
  });
};

const EpisodeSchema = yup.object().shape({
  title: yup.string().required('This field is required'),
  description: yup.string().required('This field is required'),
  status: yup
    .string()
    .not(['initial'], 'Por favor seleccione otro estado')
    .required('This field is required'),
  activity: yup
    .string()
    .not(['initial'], 'Por favor seleccione otro estado')
    .required('This field is required'),
  cover: yup.string().notRequired('Este campo no es requerido'),
  tags: yup.array().required('Este campo es requerido'),
  emotions: yup.number().required('This field is required'),
  relations: yup.number().required('This field is required'),
  transformation: yup.number().required('This field is required'),
  selfEsteem: yup.number().required('This field is required'),
  purpose: yup.number().required('This field is required')
});

const CoverUploadComponent = ({ handleChange, values }) => {
  const [avatar, setAvatar] = useState(values.cover ? values.cover : '');
  const [prev] = useState(values.cover ? values.cover : '');
  const [progress, setProgress] = useState({
    per: 0,
    text: '0%',
    started: false
  });
  const handleUpdateState = (value) => {
    const e = {
      target: {
        name: 'cover',
        value
      }
    };
    handleChange(e);
  };

  const handleFileUpload = async (files) => {
    try {
      const data = new FormData();
      data.append('file', files[0]);
      const config = {
        onUploadProgress(progressEvent) {
          const percentCompleted = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          );
          const text = `${percentCompleted}%`;
          setProgress({
            per: percentCompleted,
            text,
            started: true
          });
        }
      };
      const res = (await api.post('/episode/file-upload', data, config)).data;
      setAvatar(res.uri);
      handleUpdateState(res.uri);
    } catch (e) {}
  };

  const handleImgChange = () => {
    setAvatar('');
    handleUpdateState('');
  };

  const handleImgReset = () => {
    setAvatar(prev);
    handleUpdateState(prev);
  };

  return (
    <Row>
      {!avatar && (
        <Col>
          <FileUploaderSingle
            handleSubmit={handleFileUpload}
            accept=".jpg,.png,.jpeg"
            show={!values.cover}
          >
            <>
              <Label className="form-label fs-6 mb-1" for="cover">
                Sube una caratula
              </Label>
              <div
                className="px-5 py-2 d-flex align-items-center justify-content-center flex-column"
                style={{
                  border: '1px dashed #7367F0',
                  borderRadius: '2.5px'
                }}
              >
                <DownloadCloud size={64} />
                <p className="text-secondary">
                  Suelta archivos aca o{' '}
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    navega
                  </a>
                </p>
                {progress.started && (
                  <div
                    className="progress"
                    style={{ width: '100%', height: 15, bottom: 0 }}
                  >
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{
                        background: '#4DFF84',
                        width: `${progress.text}`
                      }}
                      aria-valuenow={progress.per}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      {progress.text}
                    </div>
                  </div>
                )}
              </div>
            </>
          </FileUploaderSingle>
          {values.cover && (
            <div className="d-flex align-items-center justify-content-center mt-75 ms-1">
              <Button color="danger" size="sm" outline onClick={handleImgReset}>
                Reiniciar
              </Button>
            </div>
          )}
        </Col>
      )}
      {avatar && (
        <Col md={4}>
          <div className="d-flex">
            <div className="me-25">
              <img
                className="rounded me-50"
                src={avatar}
                alt="Generic placeholder image"
                height="250"
                width="250"
              />
              <div className="d-flex align-items-center justify-content-center mt-75 ms-1">
                <Button
                  color="danger"
                  size="sm"
                  outline
                  onClick={handleImgChange}
                >
                  Cambiar
                </Button>
              </div>
            </div>
          </div>
        </Col>
      )}{' '}
    </Row>
  );
};

const EpisodeDetails = ({ stepper, handleOnSubmit, defaultValues }) => {
  const [activityData, setActivityData] = useState([]);
  const [tagsSelected, setTagsSelected] = useState([]);
  const [gender, setGender] = useState(defaultValues.gender || []);
  const [getListTags] = useMutation(ListTags);
  const [options, setOptions] = useState([]);
  const { loading } = useQuery(FilterActivities, {
    variables: {
      search: {
        page: 1,
        q: '',
        perPage: 1000,
        type: '',
        status: 'ACTIVE'
      }
    },
    onCompleted: (data) => {
      setActivityData(() =>
        data.listActivities.docs.map((item) => ({
          value: item._id,
          label: item.name
        }))
      );
    }
  });

  const onSubmit = (data, { errors }) => {
    if (!data.cover) {
      handleWarning();
      return;
    }

    const tags = tagsSelected.map((item) => item._id);
    if (!errors || isObjEmpty(errors)) {
      const check = {
        emotions: parseInt(data['emotions']),
        relations: parseInt(data['relations']),
        transformation: parseInt(data['transformation']),
        selfEsteem: parseInt(data['selfEsteem']),
        purpose: parseInt(data['purpose'])
      };
      handleOnSubmit({
        ...data,
        gender,
        tags,
        pillars: check,
        emotions: undefined,
        relations: undefined,
        transformation: undefined,
        selfEsteem: undefined,
        purpose: undefined
      });
      stepper.next();
    }
  };

  const seletGender = (e) => {
    console.log(e.target.id, e.target.checked);
    if (e.target.checked) {
      setGender([...gender, e.target.id]);
    } else {
      const a = gender.filter(g => g !== e.target.id);
      setGender(a);
    }

  };
  
  const handleFetching2 = async ({ _page, _q, _perPage, _type, _status }) => {
    try {
      const {
        data: { listTags: data }
      } = await getListTags({
        variables: {
          searchTag: {
            status: _status,
            q: _q,
            perPage: _perPage,
            type: _type,
            page: _page,
            sort: '',
            sortColumn: ''
          }
        }
      });
      const _data = new Map();
      const res = new Map();

      defaultValues.tags.forEach((tag) => {
        res.set(tag, {});
      });
      data.docs.forEach((tag) => {
        if (res.get(tag._id)) {
          res.set(tag._id, tag);
        } else {
          _data.set(tag._id, tag);
        }
      });
      setOptions([..._data.values()]);
      setTagsSelected([...res.values()]);
    } catch (e) {
      return [];
    }
  };

  useEffect(() => {
    handleFetching2({
      _page: 1,
      _q: '',
      _perPage: 1000,
      _type: 'EMPTY',
      _status: 'ACTIVE'
    });
  }, []);

  return (
    <>
      <div className="content-header">
        <h5 className="mb-0">Detalles del Episodio</h5>
        <small className="text-muted">Datos básicos del episodio</small>
      </div>
      <Formik
        initialValues={{
          ...defaultValues
        }}
        validateOnChange
        validateOnBlur
        validate={(values) => {
          const check = {
            emotions: parseInt(values['emotions']),
            relations: parseInt(values['relations']),
            transformation: parseInt(values['transformation']),
            selfEsteem: parseInt(values['selfEsteem']),
            purpose: parseInt(values['purpose'])
          };

          const { errors } = getNumbersBigThatRecursive(check);
          return errors;
        }}
        validationSchema={EpisodeSchema}
        onSubmit={onSubmit}
      >
        {({
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          errors,
          touched
        }) => (
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md="3" className="mb-1">
                <Label className="form-label" for="title">
                  Titulo
                </Label>
                <Input
                  type="text"
                  name="title"
                  id="title"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.title}
                  placeholder="Titulo..."
                  invalid={errors.title && true}
                />
                {errors.title && touched.title && (
                  <FormFeedback>Required</FormFeedback>
                )}
              </Col>
              <Col md="3" className="mb-1">
                <Label className="form-label" for="description">
                  Descripción corta
                </Label>
                <Input
                  type="text"
                  id="description"
                  name="description"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.description}
                  placeholder="Escribe la descripcion"
                  invalid={errors.description && true}
                />
                {errors.description && touched.description && (
                  <FormFeedback>Required</FormFeedback>
                )}
              </Col>
              <Col md="3" className="mb-1">
                <Label className="form-label" for="status">
                  Estado
                </Label>
                <Input
                  type="select"
                  name="status"
                  id="status"
                  placeholder="Seleccionar Estado"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.status}
                  invalid={errors.status && true}
                  required
                >
                  <option disabled value="initial">
                    Seleccionar Estado
                  </option>
                  <option value={true}>Activo</option>
                  <option value={false}>Inactivo</option>
                </Input>
                {errors.status && touched.status && (
                  <FormFeedback>Required</FormFeedback>
                )}
              </Col>
              <Col md="3" className="mb-1">
                <Label className="form-label" for="activity">
                  Actividad
                </Label>
                <Input
                  type="select"
                  name="activity"
                  id="activity"
                  placeholder="Seleccionar Actividad"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.activity}
                  invalid={errors.activity && true}
                  required
                  disabled={loading}
                >
                  <option disabled value="initial">
                    Seleccionar Actividad
                  </option>
                  {activityData.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </Input>
                {errors.activity && touched.activity && (
                  <FormFeedback>Required</FormFeedback>
                )}
              </Col>
            </Row>
            <Row className=" mt-2">
              <Col md={5}>
                <CoverUploadComponent
                  handleChange={handleChange}
                  values={values}
                />
              </Col>
              <Col>
                <Row>
                  <Col>
                    <Row>
                      <Col>
                        <Label className="form-label mb-1" for="emotions">
                          Emociones
                        </Label>
                        <Input
                          type="select"
                          name="emotions"
                          id="emotions"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.emotions}
                          required
                          invalid={errors.emotions && true}
                        >
                          {Options}
                        </Input>
                      </Col>
                      <Col>
                        <Label className="form-label mb-1" for="emotions">
                          Relaciones
                        </Label>
                        <Input
                          type="select"
                          name="relations"
                          id="relations"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.relations}
                          invalid={errors.relations && true}
                          required
                        >
                          {Options}
                        </Input>
                      </Col>
                      <Col>
                        <Label className="form-label mb-1" for="emotions">
                          Transformacion
                        </Label>
                        <Input
                          type="select"
                          name="transformation"
                          id="transformation"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.transformation}
                          invalid={errors.transformation && true}
                          required
                        >
                          {Options}
                        </Input>
                      </Col>
                      <Col>
                        <Label className="form-label mb-1" for="emotions">
                          Sentido de Vida
                        </Label>
                        <Input
                          type="select"
                          name="purpose"
                          id="purpose"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.purpose}
                          invalid={errors.purpose && true}
                          required
                        >
                          {Options}
                        </Input>
                      </Col>
                      <Col>
                        <Label className="form-label mb-1" for="emotions">
                          Amor Propio
                        </Label>
                        <Input
                          type="select"
                          name="selfEsteem"
                          id="selfEsteem"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.selfEsteem}
                          invalid={errors.selfEsteem && true}
                          required
                        >
                          {Options}
                        </Input>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12}>
                    <Label className="form-label mt-3" for="name">
                      Agregar Tags
                    </Label>
                    <SelectAsyncOptions
                      theme={selectThemeColors}
                      disabled={false}
                      options={options}
                      tagsSelected={tagsSelected}
                      setOptions={setTagsSelected}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="mb-1">
              <Col md="3" className="mb-1">
                <FormGroup>
                  <Label className="form-label">
                    Género
                  </Label>
                  
                  <FormGroup check>
                    <Input
                      name="gender"
                      type="checkbox"
                      value='FEMALE'
                      checked={gender.filter(e => e === 'FEMALE').length > 0} 
                      onChange={seletGender}
                      id="FEMALE"
                    />
                    <Label className="form-label" for="female">
                      Femenino
                    </Label>
                  </FormGroup>
                  <FormGroup check>
                    <Input
                      name="gender"
                      type="checkbox"
                      value='MALE'
                      checked={gender.filter(e => e === 'MALE').length > 0} 
                      onChange={seletGender}
                      onBlur={handleBlur}
                      id="MALE"
                    />
                    {' '}
                    <Label className="form-label" for="male">
                      Masculino
                    </Label>
                  </FormGroup>
                  <FormGroup
                    check>
                    <Input                      
                      name="gender"
                      type="checkbox"
                      value='OTHER'
                      checked={gender.filter(e => e === 'OTHER').length > 0} 
                      onChange={seletGender}
                      onBlur={handleBlur}
                      id='OTHER'
                    />
                    <Label className="form-label" for="other">
                      Otros
                    </Label>
                  </FormGroup>
                </FormGroup>      
              </Col>
            </Row>
            <div className="d-flex justify-content-between">
              <Button
                type="button"
                color="secondary"
                className="btn-prev"
                outline
                disabled
              >
                <ArrowLeft size={14} className="align-middle me-sm-25 me-0" />{' '}
                <span className="align-middle d-sm-inline-block d-none">
                  Previous
                </span>
              </Button>
              <Button type="submit" color="primary" className="btn-next">
                <span className="align-middle d-sm-inline-block d-none">
                  Siguiente
                </span>
                <ArrowRight size={14} className="align-middle ms-sm-25 ms-0" />
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default EpisodeDetails;
